import React from 'react';

const TFJS_Operations = () => {
    return (
        <div>TFJS_Operations Component</div>
    );
}

export default TFJS_Operations;
